import { createFileRoute } from '@tanstack/react-router';

import { getInventoryQueryOptions } from '@/_pages/inventories/api-service';
import Loading from '@/_pages/inventories/profile/loading';

export const Route = createFileRoute('/_private/inventory/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getInventoryQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: true,
    hasEditableHeader: true,
    pageTitle: 'Profile',
    tabKey: 'inventory/profile',
  },
  pendingComponent: Loading,
});
